/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { paymentMethodUpdateSchema } from "./schemas/_model";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import ControlledSelect from "components/FormInputs/ControlledSelect";
import { useUpdatePaymentMethodMutation } from "services/orders";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const paymentMethods = [
  { value: "BANK", label: "Bank" },
  { value: "CREDIT", label: "Credit" },
  { value: "CARD", label: "Card" },
];

const EditPaymentMethod = ({
  orderId,
  currentPaymentMethod,
  openPaymentMethodEdit,
  setOpenPaymentMethodEdit,
}) => {
  const initialFormState = {
    paymentMethod: "",
  };

  const { control, handleSubmit, setValue, reset, formState } = useForm({
    resolver: yupResolver(paymentMethodUpdateSchema),
    defaultValues: initialFormState,
    mode: "onChange",
  });

  const [changePaymentMethod] = useUpdatePaymentMethodMutation();

  const handleDialogClose = () => {
    setOpenPaymentMethodEdit(false);
  };

  useEffect(() => {
    if (currentPaymentMethod) setValue("paymentMethod", currentPaymentMethod);
  }, [currentPaymentMethod]);

  const onSubmitpaymentMethod = async (data) => {
    // orderId
    try {
      changePaymentMethod({ order_id: orderId, data })
        .then((response) => {
          if (response.data?.status == "success") {
            Notify.success("Successfully updated!");
          } else {
            Notify.failure("Something went wrong!");
          }
        })
        .catch((e) => console.log(e));
    } catch (e) {
      console.log(e);
    } finally {
      handleDialogClose();
      reset();
    }
  };

  return (
    <>
      <BootstrapDialog
        // onClose={handleDialogClose}
        aria-labelledby="customized-dialog-title"
        maxWidth="lg"
        sx={{
          "& .MuiPaper-root": {
            width: "650px",
          },
        }}
        open={openPaymentMethodEdit}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: "#4b4b4f" }} id="customized-dialog-title">
          Edit Payment Method of #{orderId}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <form>
            <ControlledSelect
              name="paymentMethod"
              control={control}
              label="Payment Method *"
              menu={{
                id: "value",
                value: "value",
                title: "Payment Methods",
                list: paymentMethods,
              }}
              sx={{
                "& .MuiFormLabel-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiInputBase-root": {
                  height: "44px",
                },
              }}
              defaultValue=""
              error={!!formState.errors.paymentMethod}
              helperText={formState.errors.paymentMethod?.message}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <MDButton
            type="submit"
            color="primary"
            variant="gradient"
            id="submit"
            onClick={handleSubmit(onSubmitpaymentMethod)}
          >
            Submit
          </MDButton>
          <MDButton color="secondary" variant="gradient" autoFocus onClick={handleDialogClose}>
            Cancel
          </MDButton>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

EditPaymentMethod.propTypes = {
  openDigitalKeysUpdateDialog: PropTypes.bool.isRequired,
  setOpenPaymentMethodEdit: PropTypes.func,
  fetchedDigitalKeys: PropTypes.array,
};

export default EditPaymentMethod;
